import {
    GetTransactionsParams,
    Transactions
} from '../pages/dashboard/payments/interfaces/Transactions';
import { useGetQuery } from './useGetQuery';
import { useQueryClient } from 'react-query';
import { TransactionStatus } from '../utils/helper';

const defaultParams: GetTransactionsParams = {
    page: 1,
    size: 10,
    status: TransactionStatus.PENDING
};

export const useApprovals = (initialParams?: GetTransactionsParams) => {
    const queryClient = useQueryClient();

    const params = initialParams || defaultParams;

    const {
        isLoading,
        entries: approvalsList,
        isFetching,
        paging
    } = useGetQuery<Transactions[]>({
        url: '/wallet/transaction',
        cacheKey: `approvals`,
        params: { ...params }
    });

    const invalidateTransactionsCache = () => {
        queryClient.invalidateQueries({ queryKey: ['approvals', params] });
    };

    return {
        isLoading,
        approvalsList,
        invalidateTransactionsCache,
        isFetching,
        approvalsPaging: paging
    };
};
